// Конфигурация API
export const config = {
  getApiUrl(): string {
    // 1) Явно заданный URL имеет приоритет
    if (import.meta.env.VITE_API_URL) {
      let url = import.meta.env.VITE_API_URL as string;
      // Нормализуем: если нет "/api" в пути — добавим "/api/v1"
      try {
        const u = new URL(url);
        // Если origin совпадает с текущим фронтендом (в т.ч. ngrok dev), используем относительный proxy-путь
        if (typeof window !== 'undefined' && window.location?.origin && u.origin === window.location.origin) {
          return '/api/v1';
        }
        if (!u.pathname.includes('/api')) {
          u.pathname = (u.pathname.replace(/\/$/, '')) + '/api/v1';
          url = u.toString();
        }
      } catch {
        // относительный путь или строка без схемы
        if (!/\/api(\/|$)/.test(url)) {
          url = (url.replace(/\/$/, '')) + '/api/v1';
        }
      }
      return url;
    }
    // 2) Если открыто на backend-порте 8000 — используем абсолютный origin
    if (typeof window !== 'undefined' && window.location?.port === '8000') {
      return `${window.location.origin}/api/v1`;
    }
    // 3) Во всех остальных случаях используем относительный путь,
    //    чтобы Vite proxy (`/api`) корректно проксировал на backend,
    //    включая сценарий с ngrok https.
    return '/api/v1';
  },

  getFrontendUrl(): string {
    if (typeof window !== 'undefined' && window.location?.origin) {
      return window.location.origin;
    }
    return 'http://localhost:3000';
  },

  getNotificationSoundUrl(): string {
    // Можно задать абсолютный URL (http/https) или относительный к фронтенду
    return import.meta.env.VITE_NOTIFICATION_SOUND_URL || '/notification.mp3';
  },

  getTelegramLoginBotUsername(): string {
    return (import.meta.env as any).VITE_TELEGRAM_LOGIN_BOT_USERNAME || 'guruapp_hub_bot';
  },

  getTelegramLoginBotId(): string {
    return (import.meta.env as any).VITE_TELEGRAM_LOGIN_BOT_ID || '8405385220';
  }
};

console.log('API URL:', config.getApiUrl());
console.log('Frontend URL:', config.getFrontendUrl());
console.log('Telegram Login Bot Username:', config.getTelegramLoginBotUsername());
console.log('Telegram Login Bot ID:', config.getTelegramLoginBotId());
console.log('User Agent:', navigator.userAgent); 